import { MDXRenderer } from "gatsby-plugin-mdx";
import React from "react";

import Seo from "../components/seo"

import TimeToRead from "../components/TimeToRead";
import GlobalLayout from "../components/GlobalLayout";

const Project = ({ pageContext }) => {
  const { title, subtitle, timeToRead, body } = pageContext;
  return (
    <GlobalLayout pageContext={ pageContext }>
      <Seo title={title} />
      <article>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <TimeToRead minutes={timeToRead}/>
        <MDXRenderer>{body}</MDXRenderer>
      </article>
    </GlobalLayout>
  );
};

export default Project;